//generic methods for editable tables are stored here
export const editableTableMixin = {
  methods: {
    currentlyNotEditingOrDeletingEntry(entry) {
      return !this.tableData[entry.index].isEdit && !this.tableData[entry.index].isDelete
    },

    editRowHandler(data) {
      this.tableData[data.index].isEdit = !this.tableData[data.index].isEdit
    },

    currentlyNotDeletingEntry(entry) {
      return !this.tableData[entry.index].isDelete
    },

    promptToConfirmDelete(entry) {
      this.tableData[entry.index].isDelete = true
    },

    stopDeleting(entry) {
      this.tableData[entry.index].isDelete = false
    },

    isNewEntry(entry) {
      // if an entry is new then it doesn't have a defined id yet
      return this.tableData[entry.index].id === undefined
    }
  }
}
